var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.147,
    height: 23.454,
    viewBox: "0 0 17.147 23.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 17.147,
    height: 23.454,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M9.18,0c.458.077.921.13,1.372.235a8.516,8.516,0,0,1,6.494,7.021,8.312,8.312,0,0,1-1.442,6.15c-1.314,1.9-2.646,3.779-3.967,5.67q-1.455,2.082-2.9,4.168c-.044.063-.09.124-.153.211-.072-.1-.135-.188-.2-.275-2.1-3.015-4.191-6.035-6.3-9.041A13.139,13.139,0,0,1,.719,11.95,8.513,8.513,0,0,1,5.793.476,18.958,18.958,0,0,1,7.812.04c.052-.011.1-.026.155-.039ZM8.4,4.267a4.263,4.263,0,1,0,4.289,4.246A4.268,4.268,0,0,0,8.4,4.267",
    transform: "translate(0 -0.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLocation);
export default __webpack_public_path__ + "static/media/nav-location.2d9fdf17e600ac0cd6ba00341ecb8877.svg";
export { ForwardRef as ReactComponent };